/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import PrivacyLegalbirdOSPageMeta from "./PrivacyLegalbirdOSPageMeta";
import Container from "@/src/components/Container/Container";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import PrivacyLegalbirdOS from "@/src/components/Privacy/PrivacyLegalbirdOS/PrivacyLegalbirdOS";

const PrivacyLegalbirdOSPage = () => {
  return (
    <LayoutPublicRoutes>
      <PrivacyLegalbirdOSPageMeta />
      <Container showVerticalPadding={false}>
        <PrivacyLegalbirdOS />
      </Container>
    </LayoutPublicRoutes>
  );
};

export default PrivacyLegalbirdOSPage;
